import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Process, RegulatoryTime, Petition } from '../interfaces/interfaces.index';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
const endpoint = `${URL_SERVICIOS}Process`;

@Injectable({
  providedIn: 'root'
})
export class ProcesoService {
  constructor(public http: HttpClient) { }

  getProcess = () =>
    this.http.get<Process[]>(`${URL_SERVICIOS}Process`, HTTP_OPTIONS).pipe(
      map(processes => processes.filter(p => !p.deletedByConcept))
    );

  getRegulatoryTimeById = (adjudgedInfoId: number) => this.http.get<RegulatoryTime>(`${URL_SERVICIOS}Process/regulatoryTime/${adjudgedInfoId}`, HTTP_OPTIONS);

  updateProcess = (petitionId: number, adjudgedUserId = 0) => this.http.put<Petition>(`${endpoint}/processPetition?petitionId=${petitionId}&userId=${adjudgedUserId}`, HTTP_OPTIONS);

  petitionPostponed = (petitionId: number) => this.http.put<Petition>(`${endpoint}/processPetitionPostponed?petitionId=${petitionId}`, HTTP_OPTIONS); 
}
